import React from "react";
// import specific_location_img from "../../images/bangalore.jpg";
import { useNavigate } from "react-router-dom";
import ChatButton from "../../components/ChatButton";
import { APP_NAME } from "../../Utils/constant";
import { handleApplyNow } from "../../Utils/navigation";

const Banglore = () => {
  const navigate = useNavigate();
  return (
    <>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper bangalore_banner">
          <div className="content_page_banner_wrapper_overlay">
            <h2>Location - Bangalore</h2>
          </div>
        </div>

        <div className="text_content_wrapper">
          <div className="text_content">
            {/* <div className="content_banner">
                <img src={specific_location_img} alt="" />
              </div> */}
            <h1 className="page_title mt30 mb20">
            Need Loan Fast? 
Get Your Instant Personal Loan in Bangalore Within Minutes!"

            </h1>
            <p>
            Bangalore(or Bengaluru), the “Silicon Valley of India” reflects a beautiful amalgamation of culture and modernity. Like Gurugram, Noida, Mumbai, etc, Bangalore is an IT hub, comprising a great number of MNCs. Unsurprisingly, it is one of the most expensive cities in India where survival is challenging, even for corporate employees. Be it transportation fares, the cost of accommodation, food, or navigating through miscellaneous expenses, the cost of living is undoubtedly high and handsome. {APP_NAME}, the best short-term loan app

in India, ensures you never run out of money or have instant access to funds in emergencies.
            </p>
            <br />
            <h3>{APP_NAME}: The Best Emergency Loan App without Checking Credit Score</h3>
            <p>
            Do you have a poor credit score? Are you desperate because your loan applications are continuously getting rejected? If your answer is yes, you are at the right place. To begin with, we are an authentic and highly reliable quick loan app, that extends its unparalleled services to the people of Bangalore. We offer unmatchable instant loans for salaried professionals, including instant personal loans online, emergency personal loans, instant small personal loans, long-term loans, and many more.
            </p><br/>
            <p>What makes us different is that we offer fair chances to even those with low CIBIL scores. Low or poor CIBIL score is generally seen as a red flag. However, our evaluation process considers a range of factors beyond your credit history, enabling you to get an instant personal loan without any hassle. Are you thinking about collateral? Don’t worry! You’ll be relieved to know that our loan services are completely collateral-free. So, what are you waiting for? If you need instant funds, download the {APP_NAME} app and APPLY NOW.</p>
            <br />
            <h3>Let’s Take a Quick Look at Our Highlights </h3>
            <p>
            Our highlights will give you valuable insights about how flexible and user-friendly our loan application and disbursal process is. Let’s have a quick look at the highlights one by one:
            </p>
            <br />
            <ul className="content_list">
            <li>
            First and foremost, the application process is paperless, requiring minimal effort. We have highly streamlined the loan application procedure by eliminating the need for physical documentation.
            </li>
            <li>We require just a handful of documents (not much), ensuring hassle-free application in minutes. </li>
            <li>Our user-friendly website and mobile app allow you to apply from the comfort of your stay, making the process convenient and effortless. </li>
            <li>The moment you fill out the application form and upload the necessary documents, your application is carefully evaluated. If you are a relevant fit, your loan is instantly approved. </li>
            <li>Once the loan is approved, we waste no time in disbursing the loan amount directly into your bank account.</li>
            </ul>
            <br />
            <h3>How to Apply for an Instant Personal Loan from {APP_NAME}?</h3>
            <p>
            Instant personal loan apply is effortless if you follow the below-mentioned steps carefully.
            </p>
            <br />
            <ul className="content_list">
              <li><b>Step 1.</b> Visit the {APP_NAME} official website at https://snappaisa.com/ and register as a new user.
              </li>
              <li><b>Step 2.</b>Enter your personal, employment, and income details carefully.</li>
              <li><b>Step 3.</b>Upload the required documents for verification and click "Submit."</li>
            </ul>
            <p>
            That’s it, the instant personal loan online application at {APP_NAME} is that simple.
            </p>
            <div className="button_container flex justify-center mt30">
              <button onClick={() => handleApplyNow(navigate)} className="button_container Link">Apply Now</button>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default Banglore;
